import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Formik, Field, Form } from 'formik';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import FormikErrorFocus from "formik-error-focus";
import { SlDrawer, SlInput ,SlIcon} from '@shoelace-style/shoelace/dist/react';
import { useFormik } from "formik";
import api from "../../services/api";
import { formatDateWithTime } from '../../utils/dateFormat';
import NoDataFound from '../../shared/NoDataFound';
import { Toast } from '../../shared/Toast';
import Paginator from '../../shared/Paginator';
import config from '../../config';
import TableLoader from '../../shared/TableLoader';
import { useDispatch, useSelector } from 'react-redux';
import { ScrollContainer } from 'react-indiana-drag-scroll';

import { debounce } from '../../utils/Debounce';
import { SlTooltip, SlIconButton, SlButton } from '@shoelace-style/shoelace/dist/react';
import { financeUserTypes } from '../../utils/constants';


const initialFinance = {
  name: '',
  email: '',
  mobile: '',
  password: '',
  user_type: 0,
}
let initialValues = JSON.parse(JSON.stringify(initialFinance));


const FinanceSchema = Yup.object().shape({
  name: Yup.string().matches(/^[a-zA-Z][a-zA-Z\s]*$/, "Name can't start with white space and should not contain special characters").required('Name is required'),
  email: Yup.string().email().required('Email is required'),
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Invalid Mobile number")
    .min(10, "Mobile must be 10 digits")
    .max(10, "Mobile must be 10 digits")
    .required("Mobile Number is required"),
  password: Yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9\./!@#$%^&*-?+~]*$/, "Password should not contain any white space").required("Password is required"),
  user_type: Yup.number().required("Designation is Required")
})


function Finance() {

  const navigate = useNavigate()

  const [delId, setDelId] = useState(-1);
  const [delname, setDelname] = useState("")
  const [del, setDel] = useState(false);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [flag, setFlag] = useState('')
  const [id, setId] = useState('');
  const [search, setSearch] = useState("")

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [otp, setOtp] = useState({});

  const handlePageClick = (event) => {
    // const newOffset = (event.selected * config.PER_PAGE) % data.length;
    // setItemOffset(newOffset);
    setCurrentPage(event.selected);
    loadData(search, event.selected);
    setOtp({});
  };
  const HeaderSearch = useSelector(state => state.Head.adssearch)

  const handleClose = () => {
    setShow(false);
    setSubmit(false);
    initialValues = JSON.parse(JSON.stringify(initialFinance));
    formik.setValues(initialValues);
    // initialFinance.name = ''
    // initialFinance.email = ''
    // initialFinance.mobile = ''
    // initialFinance.password = ''
  }

  const handleShow = (choose, item) => {
    if (choose === "add") {
      formik.setValues(item);
      setShow(true);
    }
    if (choose === 'edit') {
      initialValues.email = item.email
      initialValues.name = item.name
      initialValues.mobile = item.mobile
      initialValues.password = item.password
      initialValues.user_type = item.user_type
      formik.setValues(initialValues);
      setShow(true)
    }
  };

  useEffect(() => {
    Header()
  }, [HeaderSearch])

  const deleteFinancer = async (id1) => {
    try {
      await api({
        url: `/user/finance_team/${id1}`,
        method: "DELETE",
        responseType: "json"
      });
      toast.success("Finance Person Deleted Successfully");
      setCurrentPage(0);
      setSearch('');
      loadData(search, 0);
    } catch (error) {
      let er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      if (error.response.status === 401)
        navigate("/")
    }
  }


  const loadData = async (searchString = '', page = 0) => {
    try {
      setLoader(true);
      let res = await api({
        url: `/user/finance_team/getFinanceteam`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          search: searchString
        }
      });
      setData(res.data.data.length ? res.data.data : [])
      setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
      setLoader(false);
    } catch (error) {
      //toast.error("Something went wrong")
      setLoader(false);
      if (error.response.status === 401)
        navigate("/")
    }
  }

  const Header = () => {
    setSearch(HeaderSearch);
    setCurrentPage(0);
    loadData(HeaderSearch, 0);
  }

  const checkstatus = async (financer_id, status) => {
    try {
      let res = await api({
        url: `/user/finance_team/changeStatus`,
        method: "POST",
        responseType: "json",
        data: { financer_id, status }
      });
      if (res.code === 200) {
        Toast('success', res.message);
        loadData(search, currentPage);
      } else {
        Toast('error', res?.message || 'Status update failed')
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong"
      Toast("error", er)
      if (error.response.status === 401)
        navigate("/")
    }
  }
  // useEffect(() => {
  // const timer = setTimeout(() => {
  // loadData(search, 0)
  // }, 200);

  // return () => clearTimeout(timer);
  // }, []);

  // useEffect(() => {
  //   loadData();
  // }, [currentPage]);

  const searchData = e => {
    setSearch(e.target.value);
    setCurrentPage(0);
    loadData(e.target.value, 0);
    setOtp({});
  }
  function handleRequestClose(event) {
    if (event.detail.source === 'overlay') {
      event.preventDefault();
    }
  }
  const handledelClose = () => {
    setDel(false)
  }

  let formik = useFormik({
    initialValues: JSON.parse(JSON.stringify(initialFinance)),
    validationSchema: FinanceSchema,
    onSubmit: async (values) => {
      if (flag === 'add') {
        try {
          let res = await api({
            url: `/user/finance_team`,
            method: "POST",
            responseType: "json",
            data: values
          });
          if (res?.data?.code === 500) {
            Toast('error', res.data.message);
          } else {
            Toast("success", "Finance Added Successfully");
            handleClose();
            setCurrentPage(0);
            setSearch('');
            loadData(search, 0);
            setOtp({});
          }
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
      }
      if (flag === 'edit') {
        try {
          await api({
            url: `/user/finance_team/${id}`,
            method: "PUT",
            responseType: "json",
            data: values
          });
          Toast("success", "Finance updated Successfully");
          handleClose()
          loadData(search, currentPage);
          setOtp({});
          values.name = ''
          values.email = ''
          values.mobile = ''
          values.password = ''
          values.user_type = 0
        } catch (error) {
          let er = error?.response?.message || "Something went wrong"
          Toast("error", er)
          if (error.response.status === 401)
            navigate("/")
        }
      }
    }
  });

  const viewOTP = async (mobile, userType, index) => {
    try {
      let res = await api({
        url: `/user/sales_persons/viewOTP`,
        method: "POST",
        responseType: "json",
        data: {
          mobileno: mobile,
          type: userType,
        },
      });
      if (res?.code === 200) {
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = res?.data?.length ? res?.data[0].otp : "OTP not found"
        setOtp(updatedOtpData);
        // Toast("success", "OTP displayed Successfully");
      } else {
        Toast("error", res.data.message);
        const updatedOtpData = { ...otp };
        updatedOtpData[index] = '';
        setOtp(updatedOtpData);
      }
    } catch (error) {
      let er = error?.response?.message || "Something went wrong";
      Toast("error", er);
      setOtp({})
      if (error.response.status === 401) navigate("/");
    }

  }


  return (
    <>
      <SlDrawer label="Are you sure!" open={del} onSlRequestClose={handleRequestClose} onSlAfterHide={handledelClose} >
        <p>The Finance Person <span style={{ fontFamily: "Arial", fontWeight: "bold" }}>{delname}</span> will be deleted</p>
        <div className='d-flex gap-2'>
          <Button variant="success" onClick={() => setDel(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => { setDel(false); deleteFinancer(delId) }}>Confirm</Button>
        </div>
      </SlDrawer>
      {/* <Modal show={del}>
        <Modal.Header>
          <Modal.Title>Are you sure!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The Finance Person <h6 className='inline underline'>{delname}</h6> will be deleted</p>
          <div className='flex gap-2'>
            <SlButton size='small' variant="danger" onClick={() => setDel(false)}>Cancel</SlButton>
            <SlButton size='small' variant="primary" onClick={() => { setDel(false); deleteFinancer(delId) }}>Confirm</SlButton>
          </div>
        </Modal.Body>
      </Modal> */}
      <div className='flex gap-4 justify-end mb-4'>
        <SlInput size="small" id="myInput" onSlInput={debounce(searchData, 500)} placeholder="Search By Name / Email / Mobile.." >
        <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
        </SlInput>
        <SlButton size="small" variant="primary" onClick={() => { handleShow("add", {}); setFlag('add') }}>Add Finance</SlButton>
      </div>
      <SlDrawer label="Create Finance Person" open={show} onSlRequestClose={handleRequestClose} onSlAfterHide={handleClose} >
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label className="mb-1"> Name</label><span className="text-red-600">*</span>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Financer Name"
              aria-label=""
              name="name"
              value={formik.values.name}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.name ? (
              <div className="text-red-600	">{formik.errors.name}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1">Email</label><span className="text-red-600">*</span>
            <input
              type='email'
              className="form-control"
              placeholder='Enter Email'
              name='email'
              aria-label=""
              value={formik.values.email}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.email ? (
              <div className="text-red-600	">{formik.errors.email}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1"> Mobile No</label><span className="text-red-600">*</span>
            <input
              className="form-control"
              type='tel'
              name='mobile'
              placeholder='Enter Mobile No'
              aria-label=""
              value={formik.values.mobile}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.mobile ? (
              <div className="text-red-600	">{formik.errors.mobile}</div>
            ) : null}
          </div>
          <div className="mb-3" >
            <label className="mb-1"> Password</label><span className="text-red-600">*</span>
            <input
              className="form-control"
              type='text'
              name='password'
              placeholder='Enter Password'
              aria-label=""
              value={formik.values.password}
              onBlur={formik.handleBlur}
              onChange={(e) => {
                formik.handleChange(e);
              }}
            />
            {submit && formik.errors.password ? (
              <div className="text-red-600	">{formik.errors.password}</div>
            ) : null}

          </div>
          <div className="mb-3">
            <label className="mb-1">Designation</label><span className="text-red-600">*</span>
            <select
              className="form-select"
              aria-label="Default select example"
              name="user_type"
              placeholder="Select Type"
              onBlur={formik.handleBlur}
              value={formik.values.user_type}
              onChange={async (e) => {
                formik.handleChange(e);
              }}
            >
              {financeUserTypes.map(item => <option value={item.value}>{item.label}</option>)}
            </select>
            {submit && formik.errors.user_type ? (
              <div className="text-red-600	">{formik.errors.user_type}</div>
            ) : null}
          </div>
          <div slot="footer">
            <SlButton
              type="submit"
              variant="primary"
              size="small"
              onClick={(e) => setSubmit(true)}>Submit</SlButton>
          </div>

        </form>
      </SlDrawer>
      {/* <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Create Finance Person</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialFinance}
            validationSchema={FinanceSchema}
            onSubmit={async (values) => {
              if (flag === 'add') {
                try {
                  let res = await api({
                    url: `/user/finance_team`,
                    method: "POST",
                    responseType: "json",
                    data: values
                  });
                  if (res?.data?.code === 500) {
                    Toast('error', res.data.message);
                  } else {
                    Toast("success", "Finance Added Successfully");
                    handleClose();
                    setCurrentPage(0);
                    setSearch('');
                    loadData(search, 0);
                  }
                } catch (error) {
                  let er = error?.response?.message || "Something went wrong"
                  Toast("error", er)
                  if (error.response.status === 401)
                    navigate("/")
                }
              }
              if (flag === 'edit') {
                try {
                  await api({
                    url: `/user/finance_team/${id}`,
                    method: "PUT",
                    responseType: "json",
                    data: values
                  });
                  Toast("success", "Finance updated Successfully");
                  handleClose()
                  loadData(search, currentPage);
                  values.name = ''
                  values.email = ''
                  values.mobile = ''
                  values.password = ''
                } catch (error) {
                  let er = error?.response?.message || "Something went wrong"
                  Toast("error", er)
                  if (error.response.status === 401)
                    navigate("/")
                }
              }
            }}>
            {({ values, errors, touched }) => (
              <Form>
                <div className="mb-3" >
                  <label className="mb-1"> Name</label>
                  <Field className="form-control" type='text' name='name' placeholder='Enter Financer Name' />
                  {errors.name && touched.name ? (<div className='text-red-600'>{errors.name}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="mb-1">Email</label>
                  <Field className="form-control" type='email' name='email' placeholder='Enter Email' />
                  {errors.email && touched.email ? (<div className='text-red-600'>{errors.email}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="col-sm-4 col-form-label"> Mobile No</label>
                  <Field className="form-control" type='tel' name='mobile' placeholder='Enter Mobile No' />
                  {errors.mobile && touched.mobile ? (<div className='text-red-600'>{errors.mobile}</div>) : null}</div>
                <div className="mb-3" >
                  <label className="mb-1"> Password</label>
                  <Field className="form-control" type='text' name='password' placeholder='Enter Password' />
                  {errors.password && touched.password ? (<div className='text-red-600'>{errors.password}</div>) : null}</div>
                <div className='text-end'><button className="btn btn-secondary" onClick={handleClose}> Cancel</button>
      <div>
        <SlButton variant='primary' size='small' type='submit'>Submit</SlButton>
      </div>
       </div> 
                <FormikErrorFocus
                  offset={0}
                  align={"top"}
                  focusDelay={100}
                  ease={"linear"}
                  duration={100}
                />
              </Form>
            )
            }
          </Formik >
        </Modal.Body >
        <Modal.Footer>
        </Modal.Footer>
      </Modal > */}
      < div className='mb-4' >
        <ScrollContainer>
        <table className='table table-bordered'>
          <thead className="sticky top-0 ">
            <tr>
              <th >Name</th>
              <th >Email</th>
              <th >Mobile</th>
              <th >Password</th>
              <th >Designation</th>
              <th >Status</th>
              <th>Created Date</th>
              <th>Created By</th>
              <th>View OTP</th>
              <th>Actions</th>
            </tr>
          </thead>
          {(data?.length && !loader) ? (
            <tbody>
              {data.map((item, index) => {
                return (
                  <tr key={item.financer_id} className="group/details hover:bg-slate-100">
                    <th scope='row' >{item.name}</th>
                    <td >{item.email}</td>
                    <td >{item.mobile}</td>
                    <td >{item.password}</td>
                    <td >{financeUserTypes.find(fitem => fitem.value === item.user_type)?.label}</td>
                    <td ><div className="form-check form-switch" style={{ marginLeft: '1rem' }}>
                      <input className="form-check-input" type="checkbox" role="switch" checked={item.status} onChange={(e) => { checkstatus(item.financer_id, item.status) }} />
                    </div></td>
                    <td >{formatDateWithTime(item.created_date)}</td>
                    <td >{item.user_name || '-'}</td>
                    <td>
                      {otp[index] ? (
                        <span>{otp[index]}</span>
                      ) : (
                        <SlTooltip content="View OTP">
                          <SlIconButton
                            library="lucide"
                            name="eye"
                            onClick={() => viewOTP(item.mobile, "financer", index)}
                          ></SlIconButton>
                        </SlTooltip>
                      )}
                    </td>
                    <td >
                      <div className='inline-flex gap-3'>
                        <SlTooltip content="Edit Finance">
                          <SlIconButton
                            library="lucide"
                            name="edit"
                            onClick={() => { handleShow("edit", item); setFlag('edit'); setId(item.financer_id) }}></SlIconButton>
                        </SlTooltip>
                        <form action="" method="POST">
                          {/* <SlTooltip content="Delete Finance">
                            <SlIconButton
                              library="lucide"
                              name="trash-2"
                              onClick={() => { setDel(true); setDelId(item.financer_id); setDelname(item.name) }}></SlIconButton>
                          </SlTooltip> */}
                        </form>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>) : ((!data?.length && !loader)
              ? <NoDataFound colspan="8" />
              : <TableLoader colspan="8" />
          )
          }
        </table>
        </ScrollContainer>
      </div >
      <div className="flex justify-end"> {totalPages > 1 && <Paginator pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} />}</div>
    </>
  )
}

export default Finance